import { render } from "./UserViewModal.vue?vue&type=template&id=34904a3c&ts=true"
import script from "./UserViewModal.vue?vue&type=script&lang=ts"
export * from "./UserViewModal.vue?vue&type=script&lang=ts"

import "./UserViewModal.vue?vue&type=style&index=0&id=34904a3c&lang=scss"

import exportComponent from "/home/meiyeer/irb-app-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__